// extracted by mini-css-extract-plugin
export default {"PhotoBox":"PhotoProfile_PhotoBox__58+BU"};